import { render, staticRenderFns } from "./CancelTransfers.vue?vue&type=template&id=d6fe511a"
import script from "./CancelTransfers.vue?vue&type=script&lang=js"
export * from "./CancelTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports